import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
axios.defaults.withCredentials = true;
import { i18n } from "./vue-i18n-plugin"
import { changeUrlSearchParams } from "./util/i18n"
import { setLS } from "./util/storage"
import { auth } from './firestore';

Vue.use(Vuex)

// ref: https://scotch.io/tutorials/handling-authentication-in-vue-using-vuex
export default new Vuex.Store({
  state: {
    status: '',
    lastPortalType: localStorage.getItem('last-portal-type'),
    user: JSON.parse(localStorage.getItem('user')) || {},
    // token: localStorage.getItem('token') || '',
    // user: {}
    qcpos: JSON.parse(localStorage.getItem('qcpos')) || {},
    appLang: {
      'zh-TW': 'zh-tw',
      'en-US': 'en'
    }[ navigator.language ] || 'en',

    cheatMode: false
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, /*token, */user) {
      state.status = 'success'
      // state.token = token
      state.user = user
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
      state.user = {};
      localStorage.removeItem('user');
    },

    qcposLogin(state, ret) {
      state.qcpos = {
        shopId: ret.shopId,
        shopName: ret.shopName,
        username: ret.username,
        token: ret.token
      };
    },
    qcposLogout(state) {
      state.qcpos = {};
      localStorage.removeItem('qcpos');
    },

    enableCheat(state) {
      state.cheatMode = true;
    },
    setLang(state, payload) {
      // change url query params
      changeUrlSearchParams('lang', payload)
      // change html lang
      document.documentElement.setAttribute('lang', payload)
      // change i18n locale (vue-i18n / Element UI / veeValidate)
      i18n.locale = payload;
      // set store state
      state.appLang = payload
      // set local storage state
      setLS("USER_LANGUAGE", payload)
    },
  },
  actions: {
    authenticate({ commit }) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios
        .get(`${process.env.VUE_APP_APIHOST}/apis/me`)
        .then(resp => {
          const user = resp.data;
          localStorage.setItem('user', JSON.stringify(user));
          localStorage.setItem('last-portal-type', user.type);
          commit('auth_success', user);
          resolve(resp);
        })
        .catch(err => {
          commit('auth_error')
          // localStorage.removeItem('token')
          reject(err)
        })
      })
      

    },
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ url: `${process.env.VUE_APP_APIHOST}/${user.type}/signin`, data: user, method: 'POST' })
          .then(resp => {
            // {"success":true,"user":{"id":1,"username":"gaa"}}
            // const token = resp.data.token
            const user = resp.data.user;
            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('last-portal-type', user.type);
            // localStorage.setItem('token', token)
            // axios.defaults.headers.common['Authorization'] = token
            // console.log('the user is ' + JSON.stringify(user));
            // commit('auth_success', token, user)
            commit('auth_success', user);
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            // localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        axios({ url: `${process.env.VUE_APP_APIHOST}/signout`, data: {}, method: 'POST' })
          .then(resp => {
            // {"success":true,"user":{"id":1,"username":"gaa"}}
            // const token = resp.data.token
            // const user = resp.data.user;
            // localStorage.setItem('user', JSON.stringify(user));
            // localStorage.setItem('token', token)
            // axios.defaults.headers.common['Authorization'] = token
            // console.log('the user is ' + JSON.stringify(user));
            // commit('auth_success', token, user)
            commit('logout')
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error');
            console.log('logout failed? ' + err.stack);
            // localStorage.removeItem('token')
            reject(err)
          })
      });

    },

    qcposLogin({ commit }, user) {
      return new Promise((resolve, reject) => {
        localStorage.setItem('last-portal-type', 'qcpos');

        //NOTE: QC-POS signin will also ask for a token for Firebase signin.
        axios.post(`${process.env.VUE_APP_APIHOST}/qcpos/signin`, user)
        .then(response => {
          console.log('QC-POS login succceeded', response.data);
          let user = response.data.user;
          // Use custom token to signin Firebase.
          auth.signInWithCustomToken(user.token)
          .then(() => {
            localStorage.setItem('qcpos', JSON.stringify(user));
            commit('qcposLogin', user);
            resolve(user);
          })
          .catch(err => {
            console.error(`QC-POS login failed: unable to signin Firebase using token.`, err);
            reject(err);
          });
          
        })
        .catch(err => {
          console.error(`QC-POS login failed`, err);
          reject(err);
        });
        
      });
    },

    qcposLogout({ commit }) {
      //TODO: Request Firebase logout.
      auth.signOut()
      .catch(err => {
        console.error(`qcposLogout failed.`, err);

        
      })
      .finally(() => {
        axios({ url: `${process.env.VUE_APP_APIHOST}/signout`, data: {}, method: 'POST' })
        .then(response => {
          commit('logout')
          // resolve(response);
        })
        .catch(err => {
          commit('auth_error');
          console.log('logout failed? ' + err.stack);
        });
      });
      commit('qcposLogout');
    },
    setLang({ commit }, payload) {
      commit("setLang", payload)
    }
  }, 
  getters: {
    userType: state => state.user && state.user.type,
    user: state => state.user,
    qcpos: state => state.qcpos,
    cheatMode: state => state.cheatMode,
    appLang: state => state.appLang,
  }
})
